import { Button } from "primereact/button";
import { FC, useState } from "react";
import { NO_IMAGE } from "../../../../assets";
import { BusinessHomeProfile } from "../../../../models/businessHomeProfile";
import { HeaderSection } from "../../../../models/manageWebSite";
import { scrollToElement } from "../../../../utils/stringUtils";
import { useAuthExperience } from "../../../auth/hooks/useAuthExperience";
import EditModal from "./EditModal";

interface Section1Props {
  data: HeaderSection | null;
  flag: boolean;
  setFlag: (flag: boolean) => void;
  homeId: string | null;
  businessData: BusinessHomeProfile | null;
}
const Section1: FC<Section1Props> = ({ data, flag, setFlag, homeId, businessData }) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const authExperience = useAuthExperience();
  const navItems = [
    { id: 11, label: "Services" },
    { id: 12, label: "Gallery" },
    { id: 13, label: "Contact" },
  ];

  return (
    <div
      style={{
        width: "100%",
        background: "linear-gradient(135deg, #0f3d63 0%, #185da2 52%, #f7a64a 100%)",
        padding: "1.25rem 1.25rem 1rem",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <div
        className="flex flex-wrap align-items-center justify-content-between gap-3"
        style={{
          background: "rgba(255,255,255,0.12)",
          border: "1px solid rgba(255,255,255,0.18)",
          borderRadius: "24px",
          padding: "0.9rem 1rem",
          backdropFilter: "blur(10px)",
        }}
      >
        <div className="flex align-items-center gap-3">
          <div
            style={{
              width: "4.6rem",
              height: "4.6rem",
              borderRadius: "20px",
              background: "rgba(255,255,255,0.96)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 14px 28px rgba(15, 61, 99, 0.22)",
              overflow: "hidden",
            }}
          >
            <img src={data?.logoSignedImg ?? NO_IMAGE} width="64" height="64" style={{ objectFit: "contain", backgroundColor: "transparent" }} />
          </div>
          <div>
            <div style={{ color: "#ffffff", fontSize: "1.2rem", fontWeight: 800 }}>
              {businessData?.businessName || `Your ${authExperience.discovery.jobWebsiteLabel}`}
            </div>
            {data?.title ? (
              <div style={{ color: "rgba(255,255,255,0.92)", fontSize: "0.98rem", fontWeight: 600, marginTop: "0.35rem" }}>
                {data.title}
              </div>
            ) : null}
          </div>
        </div>

        <div className="flex flex-wrap align-items-center gap-2">
          {navItems.map((obj) => (
            <button
              key={obj.id}
              type="button"
              onClick={() => scrollToElement(`${obj.id}`)}
              style={{
                border: "1px solid rgba(255,255,255,0.24)",
                background: "rgba(255,255,255,0.12)",
                color: "#ffffff",
                borderRadius: "999px",
                padding: "0.6rem 0.9rem",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              {obj.label}
            </button>
          ))}
          <Button severity="warning" label="Edit Header" onClick={() => setOpenModal(true)} className="website-section-action-button" />
        </div>
      </div>
      <EditModal
        isOpen={openModal}
        toggleModal={setOpenModal}
        flag={flag}
        setFlag={setFlag}
        data={data}
        homeId={homeId}
      />
    </div>
  );
};

export default Section1;
